module.exports = __webpack_public_path__ + "static/media/wechat-brands.0125ab9a.svg";